export default "__VITE_ASSET__1eeae55e__"